import { OTA_POS } from "./ota_pos.model";
import { OTA_VehAvailRQCore } from "./ota_vehavailrqcore.model";
import { OTA_VehAvailRQInfo } from "./ota_vehavailrqinfo.model";

export class OTA_VehAvailRateRQ {
    public pos = new OTA_POS();
    public vehAvailRQCore = new OTA_VehAvailRQCore();
    public vehAvailRQInfo = new OTA_VehAvailRQInfo();
}
